import attachEnvsToWindowObj from "./utilities/attachEnvsToWindowObj";
attachEnvsToWindowObj(process.env);

import("./bootstrap");
